<template>
  <button class="btn btn__copy" :data-clipboard-text="text">
    <span class="txt">{{ $t('general.actions.copy') }}</span>
    <span class="txt-active">{{ $t('general.labels.copied') }}!</span>
  </button>
</template>

<script>
import Clipboard from 'clipboard';

export default {
  props: [
    'text',
  ],
  mounted() {
    const clipboard = new Clipboard(this.$el);

    clipboard.on('success', () => {
      this.$el.classList.add('active');

      setTimeout(() => {
        this.$el.classList.remove('active');
      }, 2000);
    });
  },
};
</script>



/** WEBPACK FOOTER **
 ** CopyButton.vue?125190aa
 **/